import React from 'react';
import { cn } from '../../lib/cn';

export function Badge({ children, className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full bg-brand-accent/15 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-brand-dark',
        className,
      )}
    >
      {children}
    </span>
  );
}
